import FileUploadContentProgressBar from '@/modules/upload/FileUploadContentProgressBar';
import FormHierarchicalTextarea from '@/modules/form/components/FormHierarchicalTextarea';
import LiveFootballMatchPlayersForm from '@/modules/live/LiveFootballMatchPlayersForm';
import NxAuthorizationFormPermissionsEditor from '@/modules/authorization/FormPermissionsEditor';
import NxClippingFormSelector from '@/modules/clipping/form/Selector';
import NxCompositionSelectorField from '@/modules/composition/CompositionSelectorForm';
import NxContentFormSelector from '@/modules/content/selector/FormSelector';
import NxContentTagSelector from '@/modules/content/taxonomy/TagFormSelector';
import NxContentTaxonomySelector from '@/modules/content/taxonomy/TaxonomyFormSelector';
import NxEntitySelector from '@/modules/entity/selector/FormSelector';
import NxEntityList from '@/modules/entity/list/FormEntityListEditor';
import NxFileFormSelector from '@/modules/file/form/FileSelector';
import NxFileImageFormSelector from '@/modules/file/form/FileImageSelector';
import NxForm from '@/modules/form/Form';
import NxFormButton from '@/modules/form/components/FormButton';
import NxFormChips from '@/modules/form/components/FormChips';
import NxFormColorPicker from '@/modules/form/components/FormColorPicker';
import NxFormContentEditor from '@/modules/form/components/FormContentEditor';
import NxFormDatePicker from '@/modules/form/components/FormDatePicker';
import NxFormDateTimePicker from '@/modules/form/components/FormDateTimePicker';
import NxFormTimePicker from '@/modules/form/components/FormTimePicker';
import NxFormFileUpload from '@/modules/upload/FormUploadFile';
import NxFormFilters from '@/modules/form/components/FormFilters';
import NxFormHtmlEditor from '@/modules/form/components/FormHtmlEditor';
import NxFormLinkedSelects from '@/modules/form/components/FormLinkedSelects';
import NxFormNavigationEditor from '@/modules/navigation/FormNavigationEditor';
import NxFormNavigationSelector from '@/modules/navigation/form/FormSelector';
import NxFormNavigationUrl from '@/modules/navigation/components/FormNavigationUrl';
import NxFormNumber from '@/modules/form/components/FormNumber';
import NxFormPassword from '@/modules/form/components/FormPassword';
import NxFormSchedule from '@/modules/form/components/FormSchedule';
import NxFormScopeGenerator from '@/modules/form/FormScopeGenerator';
import NxFormSelect from '@/modules/form/components/FormSelect';
import CombinationSelectField from '@/modules/form/components/FormCombinationSelect';
import NxFormTagSelector from '@/modules/taxonomy/selector/TagFormSelector';
import NxFormText from '@/modules/form/components/FormText';
import NxFormTextArea from '@/modules/form/components/FormTextarea';
import NxFormTextEditor from '@/modules/form/components/FormTextEditor';
import NxImagePreview from '@/modules/form/components/ImagePreview';
import NxKeyValueEditor from '@/modules/form/components/FormKeyValue';
import NxLiveMessageEditor from '@/modules/live-messages/components/MessageEditor';
import NxMediaFormSelector from '@/modules/media/MediaFormSelector';
import NxMediaTaxonomySendings from '@/modules/central-newsroom/form/FormMediaTaxonomySendings';
import NxMediaTaxonomyExcludingSendings from '@/modules/central-newsroom/form/FormMediaTaxonomyExcludingSendings';
import NxMileniumPagePositionEditor from '@/modules/milenium/MileniumPagePositionEditor';
import NxRelationForm from '@/modules/relation/Form';
import NxSEOFormEditor from '@/modules/seo/FormEditor';
import NxSEOFormSiteEditor from '@/modules/seo/FormSiteEditor';
import NxSEOFormTaxonomyEditor from '@/modules/seo/FormTaxonomyEditor';
import NxSiteFormSelector from '@/modules/site/FormSelector';
import NxSocialNetworkSendings from '@/modules/social-network/FormSendingEditor';
import NxStringArraySelector from '@/modules/form/components/FormStringArraySelector';
import NxStringArrayList from '@/modules/form/components/FormStringArrayList';
import NxSwitch from '@/modules/form/components/FormSwitch';
import NxTaxonomyFormSelector from '@/modules/taxonomy/selector/FormSelector';
import NxUrlFormSelector from '@/modules/url/UrlFormSelector';
import NxUrlPathFormSelector from '@/modules/url/UrlPathFormSelector.vue';
import RelatedEntitiesField from '@/components/more-info/RelatedEntities';
import BoundField from '@/modules/form/components/FormBoundField';
import ClearableField from '@/modules/form/components/FormClearableField.vue';
import BulkEditableField from '@/modules/form/components/FormBulkEditableField.vue';
import LayoutTwoColumns from '@/modules/form/components/LayoutTwoColumns';
import LayoutThreeColumns from '@/modules/form/components/LayoutThreeColumns';
import LayoutFourColumns from '@/modules/form/components/LayoutFourColumns';
import NotificationPreview from '@/modules/notification/components/NotificationPreview';
import FormYearPicker from '@/modules/form/components/FormYearPicker.vue';
import CentralNewsroomBoundField from '@/modules/form/components/CentralNewsroomBoundField.vue';
import CentralNewsroomDistributedContentField from '@/modules/form/components/CentralNewsroomDistributedContentField.vue';
import StaffHomepageFormSelector from '@/modules/staff/components/StaffHomepageFormSelector.vue';

import siteComponents from './site-components';
import FormScrollytellingField from '@/modules/scrollytelling/FormScrollytellingField';
import VideoRenditionSetList from '@/modules/video/components/VideoRenditionSetList';

export default {
  ...siteComponents,

  // Old components, delete when all the projects use the api-components library
  NxBodyText: NxFormContentEditor,
  NxButton: NxFormButton,
  NxClippingSelector: NxClippingFormSelector,
  NxColor: NxFormColorPicker,
  NxContentSelector: NxContentFormSelector,
  NxContentTagSelector,
  NxContentTaxonomySelector,
  NxDate: NxFormDatePicker,
  NxDateTime: NxFormDateTimePicker,
  NxEntitySelector, // este sólo se usa en el formulario de Staff
  NxFileImageSelector: NxFileImageFormSelector,
  NxFileSelector: NxFileFormSelector,
  NxFilters: NxFormFilters,
  NxForm,
  NxFormButton,
  NxFormFilters,
  NxFormGeolocation: NxFormText,
  NxFormNavigationUrl,
  NxFormPassword,
  NxFormSchedule,
  NxFormScopeGenerator,
  NxFormSelect,
  NxFormText,
  NxHtmlTextarea: NxFormHtmlEditor,
  NxImagePreview,
  NxKeyValueEditor,
  NxLiveMessageEditor,
  NxMediaTaxonomySendings,
  NxNavigation: NxFormNavigationEditor,
  NxNavigationSelector: NxFormNavigationSelector,
  NxNavigationUrl: NxFormNavigationUrl,
  NxPassword: NxFormPassword,
  NxPermission: NxAuthorizationFormPermissionsEditor,
  NxRelation: NxRelationForm,
  NxRichText: NxFormTextEditor,
  NxSchedule: NxFormSchedule,
  NxSelect: NxFormSelect,
  NxSeo: NxSEOFormEditor,
  NxSeoSite: NxSEOFormSiteEditor,
  NxSeoTaxonomy: NxSEOFormTaxonomyEditor,
  NxSiteSelector: NxSiteFormSelector,
  NxSocialNetworkSendings,
  NxCompositionSelectorField,
  NxStringArraySelector,
  NxStringArrayList,
  NxSwitch,
  NxTagSelector: NxFormTagSelector,
  NxTaxonomySelector: NxTaxonomyFormSelector,
  NxText: NxFormText,
  NxTextarea: NxFormTextArea,
  NxTextUrl: NxFormText,
  NxUrl: NxUrlFormSelector,

  // Refactor V2 Components. Fields used by BCubeCMS API Library
  // Delete the old ref when all forms are migrated
  TextField: NxFormText,
  TextareaField: NxFormTextArea,
  MultipleTextField: NxStringArraySelector,
  ColorField: NxFormColorPicker,
  NumberField: NxFormNumber,
  HierarchicalTextareaField: FormHierarchicalTextarea,
  UrlNavigationField: NxFormNavigationUrl,

  HTMLField: NxFormHtmlEditor,
  QuillField: NxFormTextEditor,
  QuillBodyField: NxFormContentEditor,

  ClippingSelectorField: NxClippingFormSelector,
  ContentSelectorField: NxContentFormSelector,
  ContentTagSelectorField: NxContentTagSelector,
  ContentTaxonomySelectorField: NxContentTaxonomySelector,
  CompositionSelectorField: NxCompositionSelectorField,
  TagSelectorField: NxFormTagSelector,
  TaxonomySelectorField: NxTaxonomyFormSelector,
  EntitySelectorField: NxEntitySelector,
  EntityListField: NxEntityList,
  FileSelectorField: NxFileFormSelector,
  FileImageSelectorField: NxFileImageFormSelector,

  DateField: NxFormDatePicker,
  TimeField: NxFormTimePicker,
  YearField: FormYearPicker,
  DateTimeField: NxFormDateTimePicker,
  GeolocationField: NxFormText, // TODO: Apuntar a componente de geolocation real

  PreviewImageField: NxImagePreview,
  LiveMessagesEditorField: NxLiveMessageEditor,
  LiveFootballMatchPlayersField: LiveFootballMatchPlayersForm,
  CentralNewsroomMediaTaxonomySendingField: NxMediaTaxonomySendings,
  CentralNewsroomMediaTaxonomyExcludingSendingField: NxMediaTaxonomyExcludingSendings,

  NavigationEditorField: NxFormNavigationEditor,
  NavigationSelectorField: NxFormNavigationSelector,
  PasswordField: NxFormPassword,
  PermissionEditorField: NxAuthorizationFormPermissionsEditor,
  ScheduleField: NxFormSchedule,
  SelectField: NxFormSelect,
  LinkedSelectField: NxFormLinkedSelects,
  SwitchField: NxSwitch,
  ButtonField: NxFormButton,
  ChipsField: NxFormChips,

  SeoField: NxSEOFormEditor,
  SeoTaxonomyField: NxSEOFormTaxonomyEditor,
  SeoSiteField: NxSEOFormSiteEditor,

  MediaSelectorField: NxMediaFormSelector,
  SiteSelectorField: NxSiteFormSelector,
  SocialNetworksSendingField: NxSocialNetworkSendings,

  RelationField: NxRelationForm,
  ConfigGeneratedRelationField: NxRelationForm,
  UrlField: NxUrlFormSelector,
  UrlPathField: NxUrlPathFormSelector,
  KeyValueField: NxKeyValueEditor,

  RelatedEntitiesField,

  FileUploadProgressBarScope: FileUploadContentProgressBar,
  FileUpload: NxFormFileUpload,

  SendToMileniumField: NxMileniumPagePositionEditor,
  CombinationSelectField,
  BoundField,
  ClearableField,
  BulkEditableField,
  ScrollytellingSlidesEditorField: FormScrollytellingField,
  LayoutTwoColumns,
  LayoutThreeColumns,
  LayoutFourColumns,
  NotificationPreviewField: NotificationPreview,
  RenditionSetField: VideoRenditionSetList,
  CentralNewsroomBoundField,
  CentralNewsroomDistributedContentField,
  StaffHomepageField: StaffHomepageFormSelector,
};
